import { bl_wrty_product_registration_hdr_RowClass, bl_wrty_product_registration_hdr_RowInterface } from "../../../dbschema";
import { BaseContainerModel } from "../../base-container.model";

export class WarrantyProductRegistrationContainerModel extends BaseContainerModel {
  bl_wrty_product_registration_hdr: bl_wrty_product_registration_hdr_RowInterface
    = new bl_wrty_product_registration_hdr_RowClass();
}